export default __webpack_public_path__ + "static/media/detail_main_img_14.c80d09f8.png";